import { ActivatedRouteSnapshot, CanActivateFn, RedirectCommand, Router } from '@angular/router';
import { inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';

import { map } from 'rxjs';

import { AuthStore } from './state/auth.store';

export const authGuard: CanActivateFn = (route: ActivatedRouteSnapshot) => {
  const authStore = inject(AuthStore);
  const platformId = inject(PLATFORM_ID);
  const router = inject(Router);

  if (isPlatformBrowser(platformId)) {
    const inviteToken = route.queryParamMap.get('inviteToken');

    if (inviteToken) {
      localStorage.setItem('inviteToken', inviteToken);
    }
  }

  return authStore.signedIn$.pipe(map((signedIn) => signedIn || new RedirectCommand(router.parseUrl('/auth'))));
};
